import React, { useState, useEffect } from 'react'
import { Card, Col, Container } from 'reactstrap'
// actions
import { getSurveyCategories, updateSurveyCategorie, addNewSurveyCategorie, deleteSurveyCategorie, updateSurveyCategorieStatus } from "../../../store/catalogs/SurveyCategories/actions"
import { useSelector, useDispatch, shallowEqual } from "react-redux";

import Table1 from "../../../components/Common/TableContainer"
import { SearchBar } from '../../../components/Common/SearchBar'
import { BackButton } from '../../../components/Common/BackButton'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { SurveyCategoryRegisterModal } from './SurveyCategoryRegisterModal';

export const CatalogLayoutCategoriesQuiz = (props) => {

    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [searchData, setSearchData] = useState('');

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getSurveyCategories(`?limit=20&page=0&search=${searchData}`))
    }, [searchData, dispatch])

    useEffect(() => {
        dispatch(getSurveyCategories("?limit=1000&page=0"))
    }, [dispatch])

    const { surveyCategories, loading, total, currentPage } = useSelector(state => ({
        surveyCategories: state.surveyCategoriesReducer.surveyCategories,
        loading: state.surveyCategoriesReducer.loading,
        surveyCategorie: state.surveyCategoriesReducer.surveyCategorie,
        total: state.surveyCategoriesReducer.total,
        currentPage: state.surveyCategoriesReducer.currentPage,
    }), shallowEqual);
    // * Redux fin

    const columns = React.useMemo(
        () => [
            {
                Header: 'Categoría',
                width: '60%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Estatus',
                width: "30%",
                Cell: ({ row }) => (
                    row.original.recordStatus === true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}> <span className="mdi mdi-18px mdi-lead-pencil p-2"></span> </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}> <span className="mdi mdi-18px mdi-delete p-2"></span> </button>
                    </div>
                ),
            },
        ],
        []
    )

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const getPagination = (params) => {
        dispatch(getSurveyCategories(`${params}&search=${searchData}`))
    }

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            dispatch(updateSurveyCategorie(updValue))
            dispatch(updateSurveyCategorieStatus({
                id: rowInfo.id,
                recordStatus: active,
            }));
        } else {
            dispatch(addNewSurveyCategorie(values))
        }
        setTimeout(() => {
            dispatch(getSurveyCategories("?limit=20&page=0"))
        },400)
        setIsUpdate(false)
        setRowInfo('')
    }

    const modalClose = () => {
        setIsUpdate(false)
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteSurveyCategorie(rowInfo))
        setRowInfo('')
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='CategoriesQuizCatalog' />

                            <Card className='' style={{ padding: 20 }}>

                                <div className='pe-1'>
                                    <BackButton props={props} />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                        <SearchBar setSearchData={setSearchData} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                        <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                    </div>
                                </div>
                                {/* </div> */}
                                <div className='ms-1'>
                                    <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={surveyCategories} />
                                </div>

                                <SurveyCategoryRegisterModal
                                    setShowModal={setShowModal1}
                                    showModal={showModal1}
                                    modalRespInfo={RegisterModalRespInfo}
                                    isUpdate={isUpdate}
                                    rowInfo={rowInfo}
                                    modalClose={modalClose}
                                />

                                <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar Categoria' modalBodyLabel='¿Está seguro que desea cambiar el estatus de la categoria de encuesta de Satisfacción seleccionada?' />

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />

                </Container>
            </div>
        </React.Fragment >
    )
}
